import { render, staticRenderFns } from "./DriverBankAccount.vue?vue&type=template&id=f4e73698"
import script from "./DriverBankAccount.vue?vue&type=script&lang=js"
export * from "./DriverBankAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports